import { render, staticRenderFns } from "./stampMain.vue?vue&type=template&id=4565bdfe&scoped=true&"
import script from "./stampMain.vue?vue&type=script&lang=js&"
export * from "./stampMain.vue?vue&type=script&lang=js&"
import style0 from "./stampMain.vue?vue&type=style&index=0&lang=css&"
import style1 from "./stampMain.vue?vue&type=style&index=1&id=4565bdfe&lang=scss&scoped=true&"
import style2 from "./stampMain.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565bdfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBottomSheet,VBtn,VDialog,VIcon,VProgressCircular,VSnackbar})
